function PageContainer({ children, from = "form" }) {
  let className = "";
  if (from === "table") {
    className = "absolute h-full";
  }
  if (from === "insights") {
    className = "overflow-x-auto";
  }
  if (from === "fullHeight") {
    className = "h-full";
  }

  return (
    <div
      className={`col-span-12 w-full ${className}`}
      style={{
        paddingLeft: "1.75rem",
        paddingRight: "1.75rem",
        paddingBottom: "1.75rem",
        paddingTop: from === "insights" ? "1.75rem" : "1.25rem",
        // background: "yellow",
      }}
    >
      {children}
    </div>
  );
}
export default PageContainer;
